// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__table {
  overflow: auto;
}
.avo__table .table-name {
  color: #4a5467;
}
.avo__table .total-result {
  font-family: "OpenSans-SemiBold";
  color: #116584;
  margin-right: 8px;
}
.avo__table .table-container {
  min-width: 100%;
  max-width: max-content;
}
.avo__table .table-container table {
  width: 100%;
}
.avo__table .table-container table .select-item {
  position: sticky;
  left: 0;
  z-index: 1;
}
.avo__table .table-container table .select-item.row {
  background: #ffffff;
}
.avo__table .table-container .head-column {
  position: relative;
}
.avo__table .table-container .head-column .head-border-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 95%;
  height: 1px;
  background-color: #cdd5df;
}
.avo__table .table-container thead > tr > td, .avo__table .table-container th {
  font-family: "OpenSans-SemiBold";
  color: #4a5467;
  padding: 12px;
  background-color: #ebf0f6;
  text-align: left;
}
.avo__table .table-container thead > tr > td .icon-sort, .avo__table .table-container th .icon-sort {
  display: inline-block;
  cursor: pointer;
  margin-left: 1rem;
  height: 16px;
  width: 16px;
}
.avo__table .table-container td {
  padding: 12px;
  color: #4a5467;
}
.avo__table .table-border-bottom {
  height: 1px;
  background: #ebf0f6;
  position: sticky;
  left: 0;
}
.avo__table .table-header {
  position: sticky;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 16px;
}
.avo__table .table-footer {
  position: sticky;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #ebf0f6;
}
.avo__table .table-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
.avo__table .table-spinner .spinner-size {
  width: 32px;
  height: 32px;
  border-color: #116584;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/table/table.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;AAGI;EACI,cCKK;ADNb;AAGI;EACI,gCAAA;EACA,cCRE;EDSF,iBAAA;AADR;AAII;EACI,eAAA;EACA,sBAAA;AAFR;AAIQ;EACI,WAAA;AAFZ;AAIY;EACI,gBAAA;EACA,OAAA;EACA,UAAA;AAFhB;AAIgB;EACI,mBC3BZ;ADyBR;AAOQ;EACI,kBAAA;AALZ;AAOY;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBCpCH;AD+Bb;AASQ;EACI,gCAAA;EACA,cCtCC;EDuCD,aAAA;EACA,yBC7CC;ED8CD,gBAAA;AAPZ;AASY;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAPhB;AAWQ;EACI,aAAA;EACA,cCtDC;AD6Cb;AAaI;EACI,WAAA;EACA,mBCjEK;EDkEL,gBAAA;EACA,OAAA;AAXR;AAcI;EACI,gBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAZR;AAeI;EACI,gBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAbR;AAgBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAdR;AAgBQ;EACI,WAAA;EACA,YAAA;EACA,qBCtFC;ADwEb","sourcesContent":["@import '../../../styles/color';\n\n.avo__table {\n    overflow: auto;\n\n    .table-name {\n        color: $neutral-70;\n    }\n    .total-result {\n        font-family: 'OpenSans-SemiBold';\n        color: $primary;\n        margin-right: 8px;\n    }\n\n    .table-container {\n        min-width: 100%;\n        max-width: max-content;\n\n        table {\n            width: 100%;\n\n            .select-item {\n                position: sticky;\n                left: 0;\n                z-index: 1;\n\n                &.row {\n                    background: $white;\n                }\n            }\n        }\n\n        .head-column {\n            position: relative;\n\n            .head-border-bottom {\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                right: 0;\n                margin: 0 auto;\n                width: 95%;\n                height: 1px;\n                background-color: $neutral-30;\n            }\n        }\n\n        thead > tr > td, th {\n            font-family: 'OpenSans-SemiBold';\n            color: $neutral-70;\n            padding: 12px;\n            background-color: $neutral-20;\n            text-align: left;\n\n            .icon-sort {\n                display: inline-block;\n                cursor: pointer;\n                margin-left: 1rem;\n                height: 16px;\n                width: 16px;\n            }\n        }\n\n        td {\n            padding: 12px;\n            color: $neutral-70;\n        }\n    }\n\n    .table-border-bottom {\n        height: 1px;\n        background: $neutral-20;\n        position: sticky;\n        left: 0;\n    }\n\n    .table-header {\n        position: sticky;\n        left: 0;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0px 24px 16px;\n    }\n\n    .table-footer {\n        position: sticky;\n        left: 0;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        padding: 12px 24px;\n        border-bottom: 1px solid $neutral-20;\n    }\n\n    .table-spinner {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .spinner-size {\n            width: 32px;\n            height: 32px;\n            border-color: $primary-50;\n        }\n    }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
